import { registerApiV1AuthRegisterPost } from '@/common/api/client/sdk.gen'
import type {
    RegisterApiV1AuthRegisterPostData,
    RegisterApiV1AuthRegisterPostError,
    RegisterApiV1AuthRegisterPostResponse,
} from '@/common/api/client/types.gen'
import { useState } from 'react'
import { useFormMutation } from '@/common/hooks/useFormMutation'
import { TelegramPixel } from '@/common/lib/telegramPixel'
import { YandexMetrica } from '@/common/lib/yandexMetrica'
import { omitRegistrationUiFields } from '../lib/utils'

type RegisterFormData = RegisterApiV1AuthRegisterPostData['body'] & {
    terms_of_service?: boolean
}

export const useRegister = () => {
    const [email, setEmail] = useState('')
    const { mutation, register, handleSubmit, errors, onSubmit, setError } = useFormMutation<
        RegisterFormData,
        RegisterApiV1AuthRegisterPostResponse,
        RegisterApiV1AuthRegisterPostError
    >({
        mutationFn: data => registerApiV1AuthRegisterPost({ body: omitRegistrationUiFields(data) }).then(r => r.data!),
        formOptions: {
            defaultValues: {
                email: '',
                password: '',
                password_confirm: '',
                terms_of_service: false,
                subscribe_marketing: false,
            },
        },
        toastOptions: {
            successMessage: 'Регистрация успешна',
            errorMessage: 'Ошибка при регистрации',
        },
        onSuccess: data => {
            YandexMetrica.reachGoal('reg_success')
            TelegramPixel.trackRegistrationSuccess()
            setEmail(data.email ?? '')
        },
        onError: error => {
            const message = error.response?.data.field_errors
                ? ''
                : error.response?.data.detail || 'Ошибка при регистрации'
            setError('root', { type: 'server', message })
        },
    })

    return {
        mutation,
        register,
        handleSubmit,
        errors,
        onSubmit,
        email,
    }
}
